
export const numberSplitor=(number)=>{
    return number.toLocaleString('IRR')
}
export const textAbbreviation=(text,limit=5)=> {
    const res = text.substring(0, limit)
    return `${res} ...`
}
export const sleep=(ms) =>{
    return new Promise(resolve => setTimeout(resolve, ms));
}
export const getRandomInt=(min, max) =>{
    return Math.floor(Math.random() * (max - min + 1) + min);
}
export const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        }
    });
}